import { render } from "./Chart.vue?vue&type=template&id=6ffb79e2&scoped=true"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=6ffb79e2&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffb79e2"]])

export default __exports__